import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledBannerAlertWrapper = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)

export const StyledBannerAlertCard = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding: ${spacing * 3}px;
    `
)

export const StyledBannerAlertTitle = styled.h3(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[950]};
        line-height: 15px;
    `
)

export const StyledBannerAlertDescription = styled.div(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        font-weight: 400;
    `
)
